module.exports = __webpack_public_path__ + "assets/img/active_4.0f121b25.svg";